import React, { useContext } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';

const Blog = () => {
  const { blog } = useContext(PortfolioContext);
  const { title, description, url, articles } = blog;

  return (
    <section id="blog">
      <Container>
        <Title title="Tech Blog" />
        <Fade bottom duration={1000} delay={400} distance="30px">
          <div className="blog-wrapper">
            <p className="blog-wrapper__eyebrow">Latest Articles</p>
            <h2 className="blog-wrapper__title">{title || 'KenRp Blog'}</h2>
            <p className="blog-wrapper__description">{description}</p>

            <Row>
              {articles.map((article) => (
                <Col lg={4} md={6} sm={12} key={article.id}>
                  <article className="blog-card">
                    <h3>{article.title}</h3>
                    <p>{article.summary}</p>
                    <a
                      className="cta-btn text-color-main"
                      href={article.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Read Article
                    </a>
                  </article>
                </Col>
              ))}
            </Row>

            <a className="cta-btn cta-btn--hero blog-wrapper__link" href={url}>
              View KenRp Blog
            </a>
          </div>
        </Fade>
      </Container>
    </section>
  );
};

export default Blog;
